import React, { useEffect } from "react";
import styles from "./Search.module.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Moods,
  CarouselCard
} from "ui";
import Text from "components/UI/Text/Text";
import { Div } from "components/Atoms";
import useResponsive from "utils/hooks/useResponsive";
import { getThumbnail } from "utils/thumbnails";
import {
  Container,
  ResultsGrid,
  ResultsTitle
} from "./styles";
import Seo from "ui/Seo";
import Skeleton from "ui/Skeleton";

const Search = () => {

  const { t } = useTranslation();
  const { isMobile } = useResponsive()

  const {
    searchResults: { contents },
    searchValue,
    isSearching
  } = useSelector(state => state.searchReducer)

  useEffect(() => {
    window.scroll({ top: 0 })
  }, [searchValue])

  if (!searchValue) {
    return (
      <Div padding={`${isMobile ? '140px' : '100px'} 16px 32px`} className={styles.search}>
        <Seo
          title={t('seoSearchTitle')}
          description={t('seoSearchDescription')}
        />

        <Text color="white" weight="semibold" priority={1} size={45} align="center">
          Flixxo Moods
        </Text>

        <Text color="white" priority={2} size={18} align="center">
          {t('moodsDescription')}
        </Text>

        <Moods />
      </Div>
    )
  }

  if (!contents || isSearching) {
    return (
      <Container>
        <ResultsTitle />

        <ResultsGrid>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </ResultsGrid>
      </Container>
    )
  }

  return (
    <Container>
      <ResultsTitle>
        {t("search-results")} {searchValue}
      </ResultsTitle>

      <ResultsGrid>
        {contents?.map((video) => (
          <CarouselCard
            key={video.uuid}
            imgSrc={getThumbnail(video)}
            to={ video.contentType === 1
              ? `/community/${video.uuid}`
              : `/series/${video.uuid}`
            }
          />
        ))}
      </ResultsGrid>
    </Container>
  );
};

export default Search;
